/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { AnimatePresence, motion } from "framer-motion";
import { memo, useEffect, useRef } from "react";
import "react-swipeable-list/dist/styles.css";
import { changeDesktopAccordionStatus } from "~/lib/store/slice/audioSlice";
import { useAppDispatch, useAppSelector } from "~/lib/store/store";
import AudioPlayerCore from "../audio/AudioPlayerCore";
import AudioPlayerModes from "../audio/AudioPlayerModes";
import AudioPlayerPopUp from "../audio/AudioPlayerPopUp";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

// Animation variants for right-to-left slide
const slideVariants = {
  hidden: {
    x: "100%",
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 100,
      damping: 20,
      duration: 0.5,
    },
  },
  exit: {
    x: "100%",
    opacity: 0,
    transition: {
      duration: 0.3,
    },
  },
};

const GlobalAudioPlayer = () => {
  const { isAudioPlay, desktopAccordionShow, audioQueue, currentAudio } = useAppSelector((state) => state.nityNiyam);
  const dispatch = useAppDispatch();
  const accordionRef = useRef<HTMLDivElement>(null);
  // Handle click outside accordion to close it (mobile only)
  const handleBackdropClick = () => {
    if (desktopAccordionShow) {
      dispatch(changeDesktopAccordionStatus(false));
    }
  };

  useEffect(() => {
    if (desktopAccordionShow) {
      // const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.classList.add("overflow-hidden");
      // if (scrollbarWidth > 0) {
      //   document.body.style.paddingRight = `${scrollbarWidth}px`;
      // }
    } else {
      document.body.classList.remove("overflow-hidden");
      // document.body.style.paddingRight = "";
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      // document.body.style.paddingRight = "";
    };
  }, [desktopAccordionShow]);

  return (
    <AnimatePresence mode="wait">
      {isAudioPlay && (
        <>
          {isAudioPlay && <AudioPlayerCore />}

          {/* Backdrop overlay on mobile - closes accordion when clicked */}
          <AnimatePresence>
            {desktopAccordionShow && (
              <motion.div
                className="fixed inset-0 bg-black/50 z-40 cursor-default"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
                onClick={handleBackdropClick}
              />
            )}
          </AnimatePresence>

          {audioQueue && audioQueue.length > 0 ? (
            <>
              {/* Accordion for desktop/laptop (md and up) */}
              <motion.div
                ref={accordionRef}
                className="flex fixed md:bottom-2 md:right-2 bottom-0 z-50 w-full md:w-auto flex-col"
                variants={slideVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
              >
                <Accordion
                  type="single"
                  collapsible={true}
                  value={desktopAccordionShow ? "item-1" : ""}
                  onValueChange={(value) => {
                    dispatch(changeDesktopAccordionStatus(value === "item-1"));
                  }}
                  className="w-full md:w-[360px] 2xl:w-[400px] shadow-[0px_4px_46px_0px_rgba(114,52,25,0.20)] rounded-xl cursor-pointer border-t-0 border-[1px] md:border-[1px] border-borderPrimary "
                >
                  <AccordionItem value="item-1" className="w-full bg-secondaryBackground rounded-xl">
                    <AccordionContent className="pb-0 pt-0 transition-all duration-500 ease-in-out relative ">
                      <AudioPlayerModes />
                    </AccordionContent>
                    <AccordionTrigger iconVisible={false} className="w-full flex justify-center items-center transition-all duration-500">
                      <AudioPlayerPopUp />
                    </AccordionTrigger>
                  </AccordionItem>
                </Accordion>
              </motion.div>
            </>
          ) : (
            <>
              <motion.div
                className="hidden md:flex fixed md:bottom-5 md:right-2 bottom-0 w-full md:w-auto shadow-[0px_4px_46px_0px_rgba(114,52,25,0.20)] rounded-xl z-50"
                variants={slideVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
              >
                <AudioPlayerPopUp />
              </motion.div>

              <motion.div
                className="md:hidden flex fixed bottom-0 z-50  w-full md:w-auto shadow-[0px_4px_46px_0px_rgba(114,52,25,0.20)] rounded-xl"
                variants={slideVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
              >
                <div className="w-full">
                  <AudioPlayerPopUp />
                </div>
              </motion.div>
            </>
          )}
        </>
      )}
    </AnimatePresence>
  );
};

export default memo(GlobalAudioPlayer);
